import type { CSSProperties } from 'react';
import { cn } from '../../lib/cn';

export function Skeleton({ className, style }: { className?: string; style?: CSSProperties }) {
  return <span aria-hidden className={cn('skeleton block', className)} style={style} />;
}

/** Скелет рядків переліку — повторює геометрію справжніх рядків (без зсуву макета). */
export function RowsSkeleton({ rows = 6, className }: { rows?: number; className?: string }) {
  const widths = [72, 58, 81, 64, 49, 76, 60, 69];
  return (
    <div role="status" aria-label="Завантаження" className={cn('divide-y divide-line', className)}>
      {Array.from({ length: rows }, (_, i) => (
        <div key={i} className="flex h-[var(--row-h)] items-center gap-3 px-4">
          <Skeleton className="size-4 rounded-full" />
          <Skeleton className="h-3 w-12" />
          <Skeleton className="h-3" style={{ width: `${widths[i % widths.length]}%`, maxWidth: 520 }} />
          <span className="ml-auto flex items-center gap-3">
            <Skeleton className="size-5 rounded-full" />
            <Skeleton className="h-3 w-14" />
          </span>
        </div>
      ))}
    </div>
  );
}
